<ng-template #modal>
    <div class="modal-header">
        <h1 class="modal-title fs-5">
            Are you sure?
        </h1>
        <button (click)="dismiss()" type="button" class="btn-close" aria-label="Close"></button>
    </div>

    <div class="modal-body container-fluid">
        <p [innerHTML]="this.message"></p>
        @if (data != null) {
            <p style="font-weight: 600;">{{ data }}</p>
        }
    </div>

    <div class="modal-footer">
        <button (click)="close()" type="submit" class="btn btn-primary"> Yes </button>
        <button (click)="dismiss()" type="button" class="btn btn-secondary">No</button>
    </div>
</ng-template>
